import { connect } from "react-redux";
import { VehicleSearchResults as Component, VehicleSearchResultsProps } from "./VehicleSearchResults.component";
import { RootState } from "../../../reducers";
import {
  getCommonBenefits,
  getLicensePlateFailedCount,
  getMethod,
  getServiceRequestPayload,
  getServiceType,
  getVehicleLookupLoading,
  getVehicleLookupSearchResults,
  getVinFailedCount,
  getVinSearchResults,
} from "../../../selector";
import {
  selectVehicle,
  selectVehicleColor,
  selectVehicleFuelType,
  changeLookupTypeMethod,
  addVehicle,
  resetSearchResults,
  resetMakeModel,
  updateVehicleInfo,
  updateServiceTransition,
} from "../../../action";

const mapStateToProps = (state: RootState) =>
  ({
    commonBenefits: getCommonBenefits(state),
    isLoading: getVehicleLookupLoading(state),
    licensePlateFailedCount: getLicensePlateFailedCount(state),
    method: getMethod(state),
    searchResults: getVehicleLookupSearchResults(state),
    serviceRequestPayload: getServiceRequestPayload(state),
    serviceType: getServiceType(state),
    vinFailedCount: getVinFailedCount(state),
    vinSearchResult: getVinSearchResults(state),
  } as Pick<
    VehicleSearchResultsProps,
    | "commonBenefits"
    | "isLoading"
    | "licensePlateFailedCount"
    | "method"
    | "searchResults"
    | "serviceRequestPayload"
    | "serviceType"
    | "vinFailedCount"
    | "vinSearchResult"
  >);

export const VehicleSearchResults = connect(mapStateToProps, {
  addVehicle,
  changeLookupTypeMethod,
  resetMakeModel,
  resetSearchResults,
  selectVehicle,
  selectVehicleColor,
  selectVehicleFuelType,
  updateServiceTransition,
  updateVehicleInfo,
} as Pick<VehicleSearchResultsProps, "addVehicle" | "changeLookupTypeMethod" | "resetMakeModel" | "resetSearchResults" | "selectVehicle" | "selectVehicleColor" | "selectVehicleFuelType" | "updateServiceTransition" | "updateVehicleInfo">)(
  Component
);
